import { CommonModule } from '@angular/common';
import { TemplateRef, EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Inject, Optional, Input, ViewChild, Output, Injector, ViewContainerRef, Renderer2, ComponentFactoryResolver, NgZone, ViewEncapsulation, NgModule } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentErrorHandler, ComponentErrorHandlerModule } from '@mt-ng2/component-error-handler';
import { Subscription } from 'rxjs';
import { MatchingStrategy, TypeAheadModuleConfigToken } from '@mt-ng2/type-ahead-control-config';
import { debounceTime } from 'rxjs/operators';

// pulled directly from this repo https://github.com/ng-bootstrap/ng-bootstrap
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/component-error-handler';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';

function TypeAheadWindowComponent_ng_container_1_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵlistener("click", function TypeAheadWindowComponent_ng_container_1_li_4_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const item_r3 = ctx.$implicit; const i_r4 = ctx.index; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.select(item_r3, i_r4); });
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelement(2, "highlighter", 5);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("active", i_r4 === ctx_r1.activeIndex);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("matchingStrategy", ctx_r1.matchingStrategy)("result", ctx_r1.getValue(item_r3))("term", ctx_r1.searchText);
} }
function TypeAheadWindowComponent_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "span", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate3("showing ", ctx_r2.startingIndex + 1, " - ", ctx_r2.startingIndex + ctx_r2.maxToShow, " of ", ctx_r2.totalItems, "");
} }
function TypeAheadWindowComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "ul", 1);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵtemplate(4, TypeAheadWindowComponent_ng_container_1_li_4_Template, 4, 5, "li", 2);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵtemplate(7, TypeAheadWindowComponent_ng_container_1_div_7_Template, 5, 3, "div", 3);
    ɵngcc0.ɵɵtext(8, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.itemsToShow);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.scrollable);
} }
const _c0 = ["inputElement"];
function TypeAheadComponent_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "input", 2, 3);
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r1.placeholder);
} }
function TypeAheadComponent_ng_container_1_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "input", 4, 3);
    ɵngcc0.ɵɵlistener("focus", function TypeAheadComponent_ng_container_1_span_4_Template_input_focus_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onFocus(); })("blur", function TypeAheadComponent_ng_container_1_span_4_Template_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onBlur(); })("click", function TypeAheadComponent_ng_container_1_span_4_Template_input_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onFocus(); })("keydown", function TypeAheadComponent_ng_container_1_span_4_Template_input_keydown_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.handleKeyDown($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r2.placeholder)("formControl", ctx_r2.inputControl);
} }
function TypeAheadComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, TypeAheadComponent_ng_container_1_span_2_Template, 5, 1, "span", 1);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵtemplate(4, TypeAheadComponent_ng_container_1_span_4_Template, 5, 2, "span", 1);
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.items);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.items);
} }
function HighlighterComponent_ng_template_0_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const part_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r3.highlightClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(part_r1);
} }
function HighlighterComponent_ng_template_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const part_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵtextInterpolate(part_r1);
} }
function HighlighterComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, HighlighterComponent_ng_template_0_span_0_Template, 2, 3, "span", 1);
    ɵngcc0.ɵɵtemplate(1, HighlighterComponent_ng_template_0_ng_template_1_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const isOdd_r2 = ctx.odd;
    const _r4 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("ngIf", isOdd_r2)("ngIfElse", _r4);
} }
function VirtualTypeAheadComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "input", 1, 2);
    ɵngcc0.ɵɵlistener("blur", function VirtualTypeAheadComponent_ng_container_1_Template_input_blur_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onBlur(); })("keydown", function VirtualTypeAheadComponent_ng_container_1_Template_input_keydown_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.handleKeyDown($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r0.placeholder)("formControl", ctx_r0.inputControl);
} }
class ContentRef {
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
class PopupService {
    constructor(_type, _injector, _viewContainerRef, _renderer, _componentFactoryResolver) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._componentFactoryResolver = _componentFactoryResolver;
    }
    open(content, context, inputs) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), 0, this._injector, this._contentRef.nodes);
            if (inputs && inputs.length > 0) {
                inputs.forEach((input) => {
                    this._windowRef.instance[input.Name] = input.Value;
                });
            }
        }
        return this._windowRef;
    }
    close() {
        if (this._windowRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
            this._windowRef = null;
            if (this._contentRef.viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
                this._contentRef = null;
            }
        }
    }
    _getContentRef(content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof TemplateRef) {
            const viewRef = this._viewContainerRef.createEmbeddedView(content, context);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef([[this._renderer.createText(`${content}`)]]);
        }
    }
}

function getProperty(item, nameOfProperty) {
    if (!nameOfProperty) {
        return item;
    }
    const props = nameOfProperty.split('.');
    let value = item;
    props.forEach((prop) => {
        value = value[prop];
    });
    return value;
}
function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function getValue(item, nameProperty, errorHandler) {
    try {
        return getProperty(item, nameProperty);
    }
    catch (error) {
        errorHandler.addError('getValue failed, check nameProperty to ensure it is valid');
        throw error;
    }
}
var Key;
(function (Key) {
    Key[Key["Tab"] = 9] = "Tab";
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["Space"] = 32] = "Space";
    Key[Key["PageUp"] = 33] = "PageUp";
    Key[Key["PageDown"] = 34] = "PageDown";
    Key[Key["End"] = 35] = "End";
    Key[Key["Home"] = 36] = "Home";
    Key[Key["ArrowLeft"] = 37] = "ArrowLeft";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowRight"] = 39] = "ArrowRight";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
})(Key || (Key = {}));

class ContainsMatcher {
    constructor(strategy) {
        this._strategy = strategy;
    }
    getCurrentStrategy() {
        return this._strategy;
    }
    getHighlightedParts(resultStr, termLC, currentIdx) {
        const resultLC = resultStr.toLowerCase();
        return resultLC.split(new RegExp(`(${regExpEscape(termLC)})`)).map((part) => {
            const originalPart = resultStr.substr(currentIdx, part.length);
            currentIdx += part.length;
            return originalPart;
        });
    }
    getItems(items, searchText, errorHandler, nameProperty = '') {
        return items.filter((item) => {
            if (!getValue(item, nameProperty, errorHandler)) {
                return false;
            }
            if (!searchText) {
                return true;
            }
            return getValue(item, nameProperty, errorHandler).toLowerCase().includes(searchText.toLowerCase());
        });
    }
}

class StartsWithMatcher {
    constructor(strategy) {
        this._strategy = strategy;
    }
    getCurrentStrategy() {
        return this._strategy;
    }
    getHighlightedParts(resultStr, termLC) {
        const resultLC = resultStr.toLowerCase();
        if (resultLC.startsWith(termLC)) {
            let result = [];
            const firstInstance = resultStr.substr(0, resultLC.indexOf(termLC) + termLC.length);
            const restOfTheString = resultStr.substr(resultLC.indexOf(termLC) + termLC.length);
            result.push(''); // They styling of the highlighter (which could use some work) expects the first part to be an empty string.
            result.push(firstInstance);
            result.push(restOfTheString);
            return result;
        }
        return [];
    }
    getItems(items, searchText, errorHandler, nameProperty = '') {
        return items.filter((item) => {
            if (!getValue(item, nameProperty, errorHandler)) {
                return false;
            }
            if (!searchText) {
                return true;
            }
            return getValue(item, nameProperty, errorHandler).toLowerCase().startsWith(searchText.toLowerCase());
        });
    }
}

class EndsWithMatcher {
    constructor(strategy) {
        this._strategy = strategy;
    }
    getCurrentStrategy() {
        return this._strategy;
    }
    getHighlightedParts(resultStr, termLC) {
        const resultLC = resultStr.toLowerCase();
        if (resultLC.endsWith(termLC)) {
            let result = [];
            const lastInstance = resultStr.substr(resultLC.lastIndexOf(termLC));
            const restOfTheString = resultStr.substr(0, resultLC.lastIndexOf(termLC));
            result.push(restOfTheString);
            result.push(lastInstance);
            return result;
        }
    }
    getItems(items, searchText, errorHandler, nameProperty = '') {
        return items.filter((item) => {
            if (!getValue(item, nameProperty, errorHandler)) {
                return false;
            }
            if (!searchText) {
                return true;
            }
            return getValue(item, nameProperty, errorHandler).toLowerCase().endsWith(searchText.toLowerCase());
        });
    }
}

class MatcherFactory {
    createMatchingStrategy(strategy) {
        switch (strategy) {
            case MatchingStrategy.Contains:
                return new ContainsMatcher(strategy);
            case MatchingStrategy.StartsWith:
                return new StartsWithMatcher(strategy);
            case MatchingStrategy.EndsWith:
                return new EndsWithMatcher(strategy);
            default:
                return new ContainsMatcher(MatchingStrategy.Contains);
        }
    }
}

class TypeAheadWindowComponent {
    constructor(cdr, typeAheadConfig) {
        this.cdr = cdr;
        this.typeAheadConfig = typeAheadConfig;
        this._searchText = '';
        this.startingIndex = 0;
        this.maxToShow = 10;
        this.activeIndex = 0;
        this.totalItems = 0;
        this.onSelection = new EventEmitter();
    }
    set searchText(value) {
        this.startingIndex = 0;
        this.activeIndex = 0;
        this._searchText = value;
    }
    get searchText() {
        return this._searchText;
    }
    get scrollable() {
        return this.maxToShow < this.totalItems;
    }
    get itemsToShow() {
        const matcher = new MatcherFactory().createMatchingStrategy(this.matchingStrategy);
        const items = matcher.getItems(this.items, this.searchText, this.errorHandler, this.nameProperty);
        this.totalItems = items.length;
        return items.slice(this.startingIndex, this.startingIndex + this.maxToShow);
    }
    ngOnInit() {
        // Prioritize the input strategy otherwise fall back on the config.
        if (this.matchingStrategy !== undefined) {
            return;
        }
        else if (this.typeAheadConfig && this.typeAheadConfig.matchingStrategy) {
            this.matchingStrategy = this.typeAheadConfig.matchingStrategy;
        }
    }
    getActive() {
        return this.itemsToShow[this.activeIndex];
    }
    getValue(item) {
        return getValue(item, this.nameProperty, this.errorHandler);
    }
    moveActivePrevious() {
        if (this.itemsToShow[this.activeIndex - 1]) {
            this.activeIndex -= 1;
        }
        else if (this.scrollable) {
            if (this.startingIndex) {
                this.startingIndex -= 1;
                this.cdr.detectChanges();
            }
        }
    }
    moveActiveNext() {
        if (this.itemsToShow[this.activeIndex + 1]) {
            this.activeIndex += 1;
        }
        else if (this.scrollable) {
            if (this.startingIndex + this.maxToShow !== this.totalItems) {
                this.startingIndex += 1;
                this.cdr.detectChanges();
            }
        }
    }
    select(item, index) {
        this.activeIndex = index;
        this.onSelection.emit(item);
    }
}
TypeAheadWindowComponent.ɵfac = function TypeAheadWindowComponent_Factory(t) { return new (t || TypeAheadWindowComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TypeAheadModuleConfigToken, 8)); };
TypeAheadWindowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TypeAheadWindowComponent, selectors: [["ng-component"]], hostAttrs: ["role", "listbox", 1, "dropdown-menu", "show"], hostBindings: function TypeAheadWindowComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function TypeAheadWindowComponent_mousedown_HostBindingHandler($event) { return $event.preventDefault(); });
    } }, inputs: { matchingStrategy: "matchingStrategy" }, decls: 3, vars: 1, consts: [[4, "componentErrorHandler"], [1, "list-group"], ["class", "list-group-item", 3, "active", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "list-group-item", 3, "click"], [3, "matchingStrategy", "result", "term"], [1, "totals-text", "text-muted"]], template: function TypeAheadWindowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, TypeAheadWindowComponent_ng_container_1_Template, 9, 2, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("componentErrorHandler", ctx.errorHandler);
    } }, directives: function () { return [ɵngcc1.ComponentErrorHandlerDirective, ɵngcc2.NgForOf, ɵngcc2.NgIf, HighlighterComponent]; }, styles: ["[_nghost-%COMP%] {\n                border: none;\n                padding: 0;\n            }\n            .list-group-item[_ngcontent-%COMP%] {\n                padding-top: 2px;\n                padding-bottom: 2px;\n                padding-left: 10px;\n                padding-right: 10px;\n            }\n            .totals-text[_ngcontent-%COMP%] {\n                padding-left: 20px;\n                font-size: small;\n                font-style: italic;\n            }"], changeDetection: 0 });
TypeAheadWindowComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [TypeAheadModuleConfigToken,] }, { type: Optional }] }
];
TypeAheadWindowComponent.propDecorators = {
    matchingStrategy: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TypeAheadWindowComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    '(mousedown)': '$event.preventDefault()',
                    class: 'dropdown-menu show',
                    role: 'listbox'
                },
                template: `
        <ng-container *componentErrorHandler="errorHandler">
            <ul class="list-group">
                <li
                    *ngFor="let item of itemsToShow; let i = index"
                    class="list-group-item"
                    [class.active]="i === activeIndex"
                    (click)="select(item, i)"
                >
                    <highlighter [matchingStrategy]="matchingStrategy" [result]="getValue(item)" [term]="searchText"></highlighter>
                </li>
            </ul>
            <div *ngIf="scrollable">
                <span class="totals-text text-muted">showing {{ startingIndex + 1 }} - {{ startingIndex + maxToShow }} of {{ totalItems }}</span>
            </div>
        </ng-container>
    `,
                styles: [`
            :host {
                border: none;
                padding: 0;
            }
            .list-group-item {
                padding-top: 2px;
                padding-bottom: 2px;
                padding-left: 10px;
                padding-right: 10px;
            }
            .totals-text {
                padding-left: 20px;
                font-size: small;
                font-style: italic;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [TypeAheadModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, { matchingStrategy: [{
            type: Input
        }] }); })();

// pulled directly from this repo https://github.com/ng-bootstrap/ng-bootstrap
// tslint:disable
class Positioning {
    getAllStyles(element) {
        return window.getComputedStyle(element);
    }
    getStyle(element, prop) {
        return this.getAllStyles(element)[prop];
    }
    isStaticPositioned(element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    }
    offsetParent(element) {
        let offsetParentEl = element.offsetParent || document.documentElement;
        while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = offsetParentEl.offsetParent;
        }
        return offsetParentEl || document.documentElement;
    }
    position(element, round = true) {
        let elPosition;
        let parentOffset = { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
        if (this.getStyle(element, 'position') === 'fixed') {
            elPosition = element.getBoundingClientRect();
        }
        else {
            const offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    }
    offset(element, round = true) {
        const elBcr = element.getBoundingClientRect();
        const viewportOffset = {
            left: window.pageXOffset - document.documentElement.clientLeft,
            top: window.pageYOffset - document.documentElement.clientTop,
        };
        let elOffset = {
            bottom: elBcr.bottom + viewportOffset.top,
            height: elBcr.height || element.offsetHeight,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left,
            top: elBcr.top + viewportOffset.top,
            width: elBcr.width || element.offsetWidth,
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    }
    positionElements(hostElement, targetElement, placement, appendToBody) {
        const hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
        const targetElStyles = this.getAllStyles(targetElement);
        const targetElBCR = targetElement.getBoundingClientRect();
        const placementPrimary = placement.split('-')[0] || 'top';
        const placementSecondary = placement.split('-')[1] || 'center';
        let targetElPosition = {
            bottom: targetElBCR.height || targetElement.offsetHeight,
            height: targetElBCR.height || targetElement.offsetHeight,
            left: 0,
            right: targetElBCR.width || targetElement.offsetWidth,
            top: 0,
            width: targetElBCR.width || targetElement.offsetWidth,
        };
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top = hostElPosition.top - (targetElement.offsetHeight + parseFloat(targetElStyles.marginBottom));
                break;
            case 'bottom':
                targetElPosition.top = appendToBody ? hostElPosition.top + hostElPosition.height : hostElPosition.top;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left - (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width;
                break;
        }
        switch (placementSecondary) {
            case 'top':
                targetElPosition.top = hostElPosition.top;
                break;
            case 'bottom':
                targetElPosition.top = appendToBody
                    ? hostElPosition.top + hostElPosition.height - targetElement.offsetHeight
                    : hostElPosition.top - targetElement.offsetHeight;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left;
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
                break;
            case 'center':
                if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                    targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
                }
                else {
                    targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
                }
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    }
    // get the available placements of the target element in the viewport depending on the host element
    getAvailablePlacements(hostElement, targetElement) {
        let availablePlacements = [];
        let hostElemClientRect = hostElement.getBoundingClientRect();
        let targetElemClientRect = targetElement.getBoundingClientRect();
        let html = document.documentElement;
        let windowHeight = window.innerHeight || html.clientHeight;
        let windowWidth = window.innerWidth || html.clientWidth;
        let hostElemClientRectHorCenter = hostElemClientRect.left + hostElemClientRect.width / 2;
        let hostElemClientRectVerCenter = hostElemClientRect.top + hostElemClientRect.height / 2;
        // left: check if target width can be placed between host left and viewport start and also height of target is
        // inside viewport
        if (targetElemClientRect.width < hostElemClientRect.left) {
            // check for left only
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'left');
            }
            // check for left-top and left-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'left', availablePlacements);
        }
        // top: target height is less than host top
        if (targetElemClientRect.height < hostElemClientRect.top) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'top');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'top', availablePlacements);
        }
        // right: check if target width can be placed between host right and viewport end and also height of target is
        // inside viewport
        if (windowWidth - hostElemClientRect.right > targetElemClientRect.width) {
            // check for right only
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'right');
            }
            // check for right-top and right-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'right', availablePlacements);
        }
        // bottom: check if there is enough space between host bottom and viewport end for target height
        if (windowHeight - hostElemClientRect.bottom > targetElemClientRect.height) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'bottom');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'bottom', availablePlacements);
        }
        return availablePlacements;
    }
    /**
     * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
     * primaryplacement: left|right
     * availablePlacementArr: array in which available placements to be set
     */
    setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        let html = document.documentElement;
        // check for left-bottom
        if (targetElemClientRect.height <= hostElemClientRect.bottom) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-bottom');
        }
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.top >= targetElemClientRect.height) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-top');
        }
    }
    /**
     * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
     * primaryplacement: top|bottom
     * availablePlacementArr: array in which available placements to be set
     */
    setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        let html = document.documentElement;
        // check for left-bottom
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.left >= targetElemClientRect.width) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-left');
        }
        if (targetElemClientRect.width <= hostElemClientRect.right) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-right');
        }
    }
}
const positionService = new Positioning();
/*
 * Accept the placement array and applies the appropriate placement dependent on the viewport.
 * Returns the applied placement.
 * In case of auto placement, placements are selected in order
 *   'top', 'bottom', 'left', 'right',
 *   'top-left', 'top-right',
 *   'bottom-left', 'bottom-right',
 *   'left-top', 'left-bottom',
 *   'right-top', 'right-bottom'.
 * */
function positionElements(hostElement, targetElement, placement, appendToBody) {
    let placementVals = Array.isArray(placement) ? placement : [placement];
    // replace auto placement with other placements
    let hasAuto = placementVals.findIndex((val) => val === 'auto');
    if (hasAuto >= 0) {
        [
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
            'left-top',
            'left-bottom',
            'right-top',
            'right-bottom',
        ].forEach(function (obj) {
            if (placementVals.find((val) => val.search('^' + obj) !== -1) == null) {
                placementVals.splice(hasAuto++, 1, obj);
            }
        });
    }
    // coordinates where to position
    let topVal = 0, leftVal = 0;
    let appliedPlacement;
    if (appendToBody) {
        // get available placements
        let availablePlacements = positionService.getAvailablePlacements(hostElement, targetElement);
        // iterate over all the passed placements
        for (let { item, index } of toItemIndexes(placementVals)) {
            // check if passed placement is present in the available placement or otherwise apply the last placement in the
            // passed placement list
            if (availablePlacements.find((val) => val === item) != null || placementVals.length === index + 1) {
                appliedPlacement = item;
                const pos = positionService.positionElements(hostElement, targetElement, item, appendToBody);
                topVal = pos.top;
                leftVal = pos.left;
                break;
            }
        }
        targetElement.style.top = `${topVal}px`;
        targetElement.style.left = `${leftVal}px`;
    }
    else {
        targetElement.style.top = 'inherit';
        targetElement.style.left = 'inherit';
    }
    return appliedPlacement;
}
// function to get index and item of an array
function toItemIndexes(a) {
    return a.map((item, index) => ({ item, index }));
}

class TypeAheadBaseComponent {
    constructor(injector, vcr, renderer, resolver, ngZone) {
        this.subscriptions = new Subscription();
        this.inputControl = new FormControl();
        this.selected = null;
        /**
         * This has to be set first for the rest of the component to work.
         * We put it at the top so it starts first, but technically there is
         * a race condition with @see {@link selectedItem}.  Maybe someone can
         * figure out a better way to handle these when you come across this
         * comment <3.
         */
        this.nameProperty = 'Name';
        this.onSelectionChanged = new EventEmitter();
        this.onReady = new EventEmitter();
        /** Placement of a typeahead accepts:
         * "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
         * "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
         * and array of above values.
         */
        this.placement = 'bottom-left';
        this.isModal = false;
        this.zIndex = 1090;
        this.maxToShow = 10;
        this.placeholder = '';
        this._popupService = new PopupService(TypeAheadWindowComponent, injector, vcr, renderer, resolver);
        this.subscriptions.add(ngZone.onStable.subscribe(() => {
            if (this.isPopupOpen()) {
                positionElements(this.inputElement.nativeElement, this._windowRef.location.nativeElement, this.placement, !this.isModal);
                renderer.setStyle(this._windowRef.location.nativeElement, 'z-index', this.zIndex);
            }
        }));
    }
    set selectedItem(value) {
        if (value) {
            this.selected = value;
            this.inputControl.patchValue(this.getValue(value));
        }
        else {
            this.selected = null;
            this.inputControl.patchValue(null);
        }
    }
    set disabled(value) {
        value ? this.inputControl.disable() : this.inputControl.enable();
    }
    ngOnInit() {
        this.onReady.emit({
            clearValue: this.clearControlValue.bind(this),
            focus: this.focusMe.bind(this),
            setValue: this.handleSelection.bind(this),
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    focusMe() {
        if (this.inputElement && this.inputElement.nativeElement && this.inputElement.nativeElement.focus) {
            this.inputElement.nativeElement.focus();
        }
    }
    clearControlValue() {
        this.handleSelection(null);
    }
    getValue(item) {
        try {
            const property = getProperty(item, this.nameProperty);
            if (property === undefined) {
                throw new Error(`Property with name ${this.nameProperty} not found`);
            }
            return property;
        }
        catch (error) {
            this.errorHandler.addError('getValue failed, check nameProperty to ensure it is valid');
            throw error;
        }
    }
    onBlur() {
        if (!this.selected || (this.selected && this.inputElement.nativeElement.value !== this.getValue(this.selected))) {
            this.handleSelection(null);
        }
        this.closePopup();
    }
    handleSelection(selected) {
        this.selected = selected;
        if (selected) {
            this.inputControl.patchValue(this.getValue(selected));
        }
        else {
            this.inputControl.patchValue('');
        }
        this.onSelectionChanged.emit({ selection: selected });
    }
    /**
     * Returns true if the typeahead popup window is displayed
     */
    isPopupOpen() {
        return this._windowRef != null;
    }
    closePopup() {
        this._popupService.close();
        this._windowRef = null;
    }
    handleKeyDown(event) {
        if (!this.isPopupOpen()) {
            return;
        }
        // tslint:disable-next-line:switch-default
        switch (event.which) {
            case Key.ArrowDown:
                event.preventDefault();
                this._windowRef.instance.moveActiveNext();
                this._windowRef.instance.cdr.detectChanges();
                break;
            case Key.ArrowUp:
                event.preventDefault();
                this._windowRef.instance.moveActivePrevious();
                this._windowRef.instance.cdr.detectChanges();
                break;
            case Key.Enter:
            case Key.Tab:
                if (!this.isPopupOpen()) {
                    break;
                }
                const result = this._windowRef.instance.getActive();
                if (result) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.handleSelection(result);
                }
                else {
                    this.handleSelection(null);
                }
                this.closePopup();
                break;
            case Key.Escape:
                event.preventDefault();
                this.handleSelection(null);
                this.closePopup();
                break;
        }
    }
}
TypeAheadBaseComponent.ɵfac = function TypeAheadBaseComponent_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
TypeAheadBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TypeAheadBaseComponent, viewQuery: function TypeAheadBaseComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { nameProperty: "nameProperty", placement: "placement", isModal: "isModal", zIndex: ["z-index", "zIndex"], maxToShow: "maxToShow", placeholder: "placeholder", selectedItem: "selectedItem", disabled: "disabled", minimumCharactersToShow: "minimumCharactersToShow" }, outputs: { onSelectionChanged: "selectionChanged", onReady: "ready" } });
TypeAheadBaseComponent.propDecorators = {
    nameProperty: [{ type: Input }],
    selectedItem: [{ type: Input, args: ['selectedItem',] }],
    disabled: [{ type: Input, args: ['disabled',] }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: false },] }],
    onSelectionChanged: [{ type: Output, args: ['selectionChanged',] }],
    onReady: [{ type: Output, args: ['ready',] }],
    placement: [{ type: Input }],
    isModal: [{ type: Input }],
    zIndex: [{ type: Input, args: ['z-index',] }],
    maxToShow: [{ type: Input }],
    placeholder: [{ type: Input, args: ['placeholder',] }],
    minimumCharactersToShow: [{ type: Input }]
};


class TypeAheadComponent extends TypeAheadBaseComponent {
    constructor(injector, vcr, renderer, resolver, ngZone) {
        super(injector, vcr, renderer, resolver, ngZone);
        this.errorHandler = new ComponentErrorHandler('TypeAheadComponent', '@mt-ng2/type-ahead-control');
        if (this.minimumCharactersToShow === undefined) {
            this.minimumCharactersToShow = 0;
        }
        this.subscriptions.add(this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
            if (value && value.trim().length >= this.minimumCharactersToShow) {
                if (!this.isPopupOpen() && value && !(this.selected && this.getValue(this.selected) === value)) {
                    this.openPopup();
                }
                else if (this._windowRef) {
                    this._windowRef.instance.searchText = value;
                    this._windowRef.instance.cdr.detectChanges();
                }
            }
            else if (this.isPopupOpen()) {
                this.closePopup();
            }
        }));
    }
    onFocus() {
        super.focusMe();
        if (!this.selected && !this.minimumCharactersToShow) {
            this.openPopup();
        }
    }
    openPopup() {
        if (!this.isPopupOpen()) {
            const componentInputs = [{ Name: 'matchingStrategy', Value: this.matchingStrategy }];
            this._windowRef = this._popupService.open(null, null, componentInputs);
            this._windowRef.instance.items = [...this.items];
            this._windowRef.instance.searchText = this.inputControl.value;
            this._windowRef.instance.nameProperty = this.nameProperty;
            this._windowRef.instance.maxToShow = this.maxToShow;
            this._windowRef.instance.errorHandler = this.errorHandler;
            this._windowRef.instance.onSelection.subscribe((result) => {
                this.handleSelection(result);
                this.closePopup();
            });
            if (!this.isModal) {
                window.document.querySelector('body').appendChild(this._windowRef.location.nativeElement);
            }
            else {
                this.inputElement.nativeElement.after(this._windowRef.location.nativeElement);
            }
        }
    }
}
TypeAheadComponent.ɵfac = function TypeAheadComponent_Factory(t) { return new (t || TypeAheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TypeAheadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TypeAheadComponent, selectors: [["mt-type-ahead"]], inputs: { items: "items", matchingStrategy: "matchingStrategy" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [[4, "componentErrorHandler"], [4, "ngIf"], ["type", "text", 1, "form-control", 3, "placeholder"], ["inputElement", ""], ["type", "text", "autocorrect", "off", "autocomplete", "off", "autocapitalize", "off", "role", "combobox", 1, "form-control", 3, "placeholder", "formControl", "focus", "blur", "click", "keydown"]], template: function TypeAheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, TypeAheadComponent_ng_container_1_Template, 6, 2, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("componentErrorHandler", ctx.errorHandler);
    } }, directives: [ɵngcc1.ComponentErrorHandlerDirective, ɵngcc2.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective], encapsulation: 2 });
TypeAheadComponent.ctorParameters = () => [
    { type: Injector },
    { type: ViewContainerRef },
    { type: Renderer2 },
    { type: ComponentFactoryResolver },
    { type: NgZone }
];
TypeAheadComponent.propDecorators = {
    items: [{ type: Input }],
    matchingStrategy: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TypeAheadComponent, [{
        type: Component,
        args: [{
                selector: '<mt-type-ahead>',
                template: `
        <ng-container *componentErrorHandler="errorHandler">
            <span *ngIf="!items">
                <input #inputElement type="text" [placeholder]="placeholder" class="form-control" />
            </span>
            <span *ngIf="items">
                <input
                    #inputElement
                    type="text"
                    [placeholder]="placeholder"
                    class="form-control"
                    autocorrect="off"
                    autocomplete="off"
                    autocapitalize="off"
                    role="combobox"
                    [formControl]="inputControl"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    (click)="onFocus()"
                    (keydown)="handleKeyDown($event)"
                />
            </span>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.NgZone }]; }, { items: [{
            type: Input
        }], matchingStrategy: [{
            type: Input
        }] }); })();

// pulled directly from this repo https://github.com/ng-bootstrap/ng-bootstrap
/**
 * A component that can be used inside a custom result template in order to highlight the term inside the text of the
 * result
 */
class HighlighterComponent {
    constructor(typeAheadConfig) {
        this.typeAheadConfig = typeAheadConfig;
        /**
         * The CSS class of the span elements wrapping the term inside the result
         */
        this.highlightClass = 'ngb-highlight';
    }
    ngOnInit() {
        // Prioritize the input strategy otherwise fall back on the config.
        if (this.matchingStrategy !== undefined) {
            return;
        }
        else if (this.typeAheadConfig && this.typeAheadConfig.matchingStrategy) {
            this.matchingStrategy = this.typeAheadConfig.matchingStrategy;
        }
    }
    /**
     * If a term is passed we used the MatcherFactory to get the highlighted parts
     * based on the matching strategy defined and the component / module level
     * @param changes changes object is not used in this method
     */
    ngOnChanges(changes) {
        const resultStr = this.toString(this.result);
        const termLC = this.toString(this.term).toLowerCase();
        let currentIdx = 0;
        if (termLC.length > 0) {
            const matcher = new MatcherFactory().createMatchingStrategy(this.matchingStrategy);
            this.parts = matcher.getHighlightedParts(resultStr, termLC, currentIdx);
        }
        else {
            this.parts = [resultStr];
        }
    }
    toString(value) {
        return value !== undefined && value !== null ? `${value}` : '';
    }
}
HighlighterComponent.ɵfac = function HighlighterComponent_Factory(t) { return new (t || HighlighterComponent)(ɵngcc0.ɵɵdirectiveInject(TypeAheadModuleConfigToken, 8)); };
HighlighterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HighlighterComponent, selectors: [["highlighter"]], inputs: { highlightClass: "highlightClass", matchingStrategy: "matchingStrategy", result: "result", term: "term" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["ngFor", "", 3, "ngForOf"], [3, "class", 4, "ngIf", "ngIfElse"], ["even", ""]], template: function HighlighterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HighlighterComponent_ng_template_0_Template, 3, 2, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.parts);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: ["\n            .ngb-highlight {\n                font-weight: bold;\n            }\n        "], encapsulation: 2, changeDetection: 0 });
HighlighterComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TypeAheadModuleConfigToken,] }, { type: Optional }] }
];
HighlighterComponent.propDecorators = {
    highlightClass: [{ type: Input }],
    result: [{ type: Input }],
    term: [{ type: Input }],
    matchingStrategy: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HighlighterComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'highlighter',
                template: `<ng-template ngFor [ngForOf]="parts" let-part let-isOdd="odd">` +
                    `<span *ngIf="isOdd; else even" [class]="highlightClass">{{part}}</span><ng-template #even>{{part}}</ng-template>` +
                    `</ng-template>`,
                styles: [`
            .ngb-highlight {
                font-weight: bold;
            }
        `]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TypeAheadModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, { highlightClass: [{
            type: Input
        }], matchingStrategy: [{
            type: Input
        }], result: [{
            type: Input
        }], term: [{
            type: Input
        }] }); })();

class VirtualTypeAheadComponent extends TypeAheadBaseComponent {
    constructor(injector, vcr, renderer, resolver, ngZone) {
        super(injector, vcr, renderer, resolver, ngZone);
        this.errorHandler = new ComponentErrorHandler('VirtualTypeAheadComponent', '@mt-ng2/type-ahead-control');
        if (this.minimumCharactersToShow === undefined) {
            this.minimumCharactersToShow = 2;
        }
        this.subscriptions.add(this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
            if (value && value.trim().length >= this.minimumCharactersToShow) {
                if (!this.isPopupOpen() && value && !(this.selected && this.getValue(this.selected) === value)) {
                    this.openPopup();
                }
                else if (this._windowRef) {
                    this.getItems(value).subscribe((items) => {
                        this._windowRef.instance.items = items;
                        this._windowRef.instance.searchText = value;
                        this._windowRef.instance.cdr.detectChanges();
                    });
                }
            }
            else if (this.isPopupOpen()) {
                this.closePopup();
            }
        }));
    }
    openPopup() {
        if (this.isPopupOpen()) {
            return;
        }
        this.getItems(this.inputControl.value).subscribe((items) => {
            this._windowRef = this._popupService.open();
            this._windowRef.instance.items = items;
            this._windowRef.instance.searchText = this.inputControl.value;
            this._windowRef.instance.nameProperty = this.nameProperty;
            this._windowRef.instance.maxToShow = this.maxToShow;
            this._windowRef.instance.errorHandler = this.errorHandler;
            this.subscriptions.add(this._windowRef.instance.onSelection.subscribe((result) => {
                this.handleSelection(result);
                this.closePopup();
            }));
            window.document.querySelector('body').appendChild(this._windowRef.location.nativeElement);
        });
    }
}
VirtualTypeAheadComponent.ɵfac = function VirtualTypeAheadComponent_Factory(t) { return new (t || VirtualTypeAheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VirtualTypeAheadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VirtualTypeAheadComponent, selectors: [["mt-virtual-type-ahead"]], inputs: { getItems: "getItems" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [[4, "componentErrorHandler"], ["type", "text", "autocorrect", "off", "autocomplete", "off", "autocapitalize", "off", "role", "combobox", 1, "form-control", 3, "placeholder", "formControl", "blur", "keydown"], ["inputElement", ""]], template: function VirtualTypeAheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, VirtualTypeAheadComponent_ng_container_1_Template, 8, 2, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("componentErrorHandler", ctx.errorHandler);
    } }, directives: [ɵngcc1.ComponentErrorHandlerDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective], encapsulation: 2 });
VirtualTypeAheadComponent.ctorParameters = () => [
    { type: Injector },
    { type: ViewContainerRef },
    { type: Renderer2 },
    { type: ComponentFactoryResolver },
    { type: NgZone }
];
VirtualTypeAheadComponent.propDecorators = {
    getItems: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VirtualTypeAheadComponent, [{
        type: Component,
        args: [{
                selector: '<mt-virtual-type-ahead>',
                template: `
        <ng-container *componentErrorHandler="errorHandler">
            <span>
                <input
                    #inputElement
                    type="text"
                    class="form-control"
                    [placeholder]="placeholder"
                    autocorrect="off"
                    autocomplete="off"
                    autocapitalize="off"
                    role="combobox"
                    [formControl]="inputControl"
                    (blur)="onBlur()"
                    (keydown)="handleKeyDown($event)"
                />
            </span>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.NgZone }]; }, { getItems: [{
            type: Input
        }] }); })();

class TypeAheadModule {
}
TypeAheadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TypeAheadModule });
TypeAheadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TypeAheadModule_Factory(t) { return new (t || TypeAheadModule)(); }, providers: [], imports: [[CommonModule, FormsModule, ReactiveFormsModule, ComponentErrorHandlerModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TypeAheadModule, { declarations: function () { return [HighlighterComponent, TypeAheadComponent, TypeAheadWindowComponent, VirtualTypeAheadComponent]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, ComponentErrorHandlerModule]; }, exports: function () { return [TypeAheadComponent, VirtualTypeAheadComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TypeAheadModule, [{
        type: NgModule,
        args: [{
                declarations: [HighlighterComponent, TypeAheadComponent, TypeAheadWindowComponent, VirtualTypeAheadComponent],
                entryComponents: [TypeAheadWindowComponent],
                exports: [TypeAheadComponent, VirtualTypeAheadComponent],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, ComponentErrorHandlerModule],
                providers: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ContentRef, PopupService, Positioning, TypeAheadComponent, TypeAheadModule, TypeAheadWindowComponent, positionElements, VirtualTypeAheadComponent as ɵa, HighlighterComponent as ɵb, TypeAheadBaseComponent as ɵc };

//# sourceMappingURL=mt-ng2-type-ahead-control.js.map